var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUtfTokenIco(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 19,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "utfTokenIco_svg__a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.000000 0 0 0 0 0.454902 0 0 0 0 0.741176 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -1.08)",
    filter: "url(#utfTokenIco_svg__a)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 2)",
    stroke: "#979797",
    strokeWidth: 1.882
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.034 3.494h6.202c.974 0 1.764.79 1.764 1.764v6.954c0 .975-.79 1.764-1.764 1.764h-6.202 0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.941,
    y: 0.941,
    width: 24.291,
    height: 15.589,
    rx: 1.764
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.966,
    cy: 8.681,
    r: 4.059
  })))));
}
export default SvgUtfTokenIco;